import memoizeFormatConstructor from 'intl-format-cache';

const getDateTimeFormat = memoizeFormatConstructor(Intl.DateTimeFormat);

const defaultOptions = {
  timeStyle: "short",
  dateStyle: "short"
} as Intl.DateTimeFormatOptions;

/**
 * Convert date to locale string using cached formatter.
 * This is much faster than Date.toLocaleString
 * */
export const toLocaleString = (text: string, language: string, options = defaultOptions): string => {
  const createdAt = new Date(text);
  const formatter = getDateTimeFormat(language, options);
  return formatter.format(createdAt);
};